import React from 'react';
import { createId, OutlinedInput, useSlug } from '@bloomberg/media-ui-core';
import { type OutlinedInputFieldProps } from '@bloomberg/media-ui-core';
import { SearchDropdownProps } from 'src/SearchDropdown/props';

import { SearchDropdown } from '../SearchDropdown/index';

export type Props = Omit<SearchDropdownProps, 'children'> & {
  size?: OutlinedInputFieldProps['size'];
  variant?: OutlinedInputFieldProps['variant'];
};

export const OutlinedSearchDropdown = React.forwardRef<HTMLDivElement, Props>(
  function Component(props, ref) {
    const {
      disabled = false,
      name: userProvidedName,
      id: userProvidedId,
      placeholder = '',
      label = '',
      size = 'default',
      variant,
      onClear,
      unstyled,
      dropdownVariant,
    } = props;

    const stableId = React.useRef(createId());

    // create a unique id for inputs
    const id = userProvidedId || stableId.current;

    const name = userProvidedName || 'OutlinedSearchDropdown';
    // stable name for data-component attribute
    const [slugName] = useSlug(name);

    // main component return
    return (
      <SearchDropdown
        {...props}
        dropdownVariant={variant === 'markets' ? 'markets' : dropdownVariant}
        name={slugName}
        ref={ref}
      >
        {({ query, labelProps, inputProps, getRootProps }) => (
          <OutlinedInput
            disableHelperText
            type="search"
            unstyled={unstyled}
            disabled={disabled}
            label={label}
            id={id}
            size={size}
            name={`${name}-input`}
            placeholder={placeholder}
            value={query}
            onClear={onClear}
            labelProps={labelProps}
            variant={variant}
            inputProps={inputProps}
            {...getRootProps()}
          />
        )}
      </SearchDropdown>
    );
  }
);
